import React, { useEffect, useState } from "react";

export interface ToastProps {
  title: string;
  description?: string;
  variant?: "default" | "destructive" | "success";
  duration?: number;
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({
  title,
  description,
  variant = "default",
  duration = 3000,
  onClose,
}) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // フェードアウト開始のタイマー
    const fadeTimer = setTimeout(() => {
      setFadeOut(true);
    }, duration - 500); // 消える500ms前にフェードアウト開始

    // 完全に閉じるタイマー
    const closeTimer = setTimeout(() => {
      onClose();
    }, duration);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(closeTimer);
    };
  }, [duration, onClose]);

  const variantStyles = {
    default: "bg-gray-700 text-white",
    destructive: "bg-red-600 text-white",
    success: "bg-green-500 text-white",
  };

  return (
    <div
      className={`fixed bottom-6 left-1/2 transform -translate-x-1/2 p-3 rounded shadow-md z-50 max-w-md transition-opacity duration-500 ${
        fadeOut ? "opacity-0" : "opacity-100"
      } ${variantStyles[variant]}`}
    >
      <div className="flex items-start">
        <div>
          <h3 className="font-medium">{title}</h3>
          {description && <p className="text-sm mt-1">{description}</p>}
        </div>
      </div>
    </div>
  );
};

export default Toast;
